import React, { useState } from "react";
import "./App.less";
import { Layout, Menu, Modal, Drawer, Button, Popover, Form, Input, notification } from "antd";
import { Route, Link, Routes, Navigate } from "react-router-dom";
import {
  ExclamationCircleOutlined,
  MenuOutlined,
  GlobalOutlined,
  FileTextOutlined,
  UserOutlined,
  AppstoreOutlined,
  BlockOutlined,
  HighlightOutlined,
  LineChartOutlined,
  MailOutlined,
  ContactsOutlined,
  ShopOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import http from "./helpers/http";
import config from "./config/config";

import NotFound from "./pages/NotFound/Index";

import Logout from "./components/Logout";
import Bookings from "./pages/Booking/Bookings";

import Setting from "./pages/Content/Setting";
import ContactLead from "./pages/ContactLead/ContactLead";
import { useTranslation } from "react-i18next";
import ProductEdit from "./pages/Product/ProductEdit";
import ProductCreate from "./pages/Product/ProductCreate";
import ProductList from "./pages/Product/ProductList";
import BlogList from "./pages/Blog/BlogList";
import BlogCreate from "./pages/Blog/BlogCreate";
import BlogEdit from "./pages/Blog/BlogEdit";
import InvestorList from "./pages/Investor/InvestorList";
import AdminList from "./pages/Admin/AdminList";
import NewsletterList from "./pages/Newsletter/NewsletterList";
import RetailerList from "./pages/Retailer/RetailerList";
import SignatureSpaceList from "./pages/SignatureSpace/SignatureSpaceList";
import SignatureSpaceCreate from "./pages/SignatureSpace/SignatureSpaceCreate";
import SignatureSpaceEdit from "./pages/SignatureSpace/SignatureSpaceEdit";
import Logo from "./logo.svg";

function MainLayout(props) {
  const { Header, Content, Footer, Sider } = Layout;
  const { SubMenu } = Menu;
  const { confirm } = Modal;
  const [collapsed, setCollapsed] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedKeys, setselectedKeys] = useState(0);
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const [form] = Form.useForm();

  const { t } = useTranslation();

  const onClose = () => {
    setOpen(false);
  };
  const onCollapse = (collapsed) => {
    setCollapsed(!collapsed);
  };

  const showLogoutConfirm = (id) => {
    confirm({
      title: t("logout.message"),
      icon: <ExclamationCircleOutlined />,
      content: "",
      okText: t("logout.yes"),
      okType: "danger",
      cancelText: t("logout.no"),

      onOk() {
        // return handleDelete(id);
        // props.history.push("/logout");
        window.location = "/logout";
      },
      onCancel() { },
    });
  };

  const handleChangePassword = async () => {
    try {
      const values = await form.validateFields();
      setChangePasswordLoading(true);
      const res = await http.post(`${config.api_url}auth/change-password`, {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      });
      if (res != null) {
        notification.success({ message: "Password changed successfully" });
        form.resetFields();
        setChangePasswordModalOpen(false);
      }
    } catch (error) {
      if (error.errorFields) return;
      notification.error({
        message: "Failed to change password",
        description: error?.message,
      });
    } finally {
      setChangePasswordLoading(false);
    }
  };
  const menuitems = [
    {
      icon: <AppstoreOutlined />,
      label: <Link to="/products?category=carpets">Carpets</Link>,
      key: "carpets",
    },
    {
      icon: <BlockOutlined />,
      label: <Link to="/products?category=rugs">Rugs</Link>,
      key: "rugs",
    },
    {
      icon: <HighlightOutlined />,
      label: <Link to="/products?category=bespoke">Bespoke</Link>,
      key: "bespoke",
    },
    {
      icon: <FileTextOutlined />,
      label: <Link to="/blogs">Blogs</Link>,
      key: "blogs",
    },
    {
      icon: <LineChartOutlined />,
      label: <Link to="/investors">Investors</Link>,
      key: "investors",
    },
    {
      icon: <UserOutlined />,
      label: <Link to="/admins">Admins</Link>,
      key: "admins",
    },
    {
      icon: <MailOutlined />,
      label: <Link to="/newsletter">Newsletter Subscribers</Link>,
      key: "newsletter",
    },
    {
      icon: <ContactsOutlined />,
      label: <Link to="/contact">Contact Leads</Link>,
      key: "contact",
    },
    {
      icon: <ShopOutlined />,
      label: <Link to="/retailer">Retailer Applications</Link>,
      key: "retailer",
    },
    {
      icon: <HighlightOutlined />,
      label: <Link to="/signature-spaces">Signature Spaces</Link>,
      key: "signaturespaces",
    },
  ];
  const languages = [
    {
      key: "en",
      label: "English",
    },
    {
      key: "fr",
      label: "French",
    },
  ];

  const content = <Menu theme="light" mode="inline" items={languages} defaultSelectedKeys={["fr"]}></Menu>;
  const topMenuItems = [
    // {
    //   label: (
    //      <LanguageSelector/>
    //     // <Popover content={content}>

    //     //   <GlobalOutlined />
    //     // </Popover>
    //   ),
    //   key: "languageSelector",
    // },
    {
      label: (
        <Link
          to=""
          onClick={() => {
            showLogoutConfirm();
          }}
        >
          {t("logout.logout")}
        </Link>
      ),
      key: "Logout",
    },
    {
      label: (
        <Link
          to=""
          onClick={(e) => {
            e.preventDefault();
            setChangePasswordModalOpen(true);
          }}
        >
          Change Password
        </Link>
      ),
      key: "ChangePassword",
    },
  ];
  const MenuComponent = (
    <Menu theme="light" mode="inline" items={menuitems}></Menu>
  );
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        // theme="dark"
        // collapsible
        // collapsed={collapsed}
        // onCollapse={() => {
        //   onCollapse(collapsed);
        // }}
        theme="light"
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          console.log(broken);
        }}
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
        trigger={null}
      >
        <div className="logo">
          <img src={Logo} className="img-fluid" />
        </div>
        {MenuComponent}
      </Sider>
      <Layout className="site-layout">
        <Header className="site-layout-background" style={{ padding: 0 }}>
          <Button
            className="menu"
            type="primary"
            icon={<MenuOutlined />}
            onClick={() => setOpen(true)}
          />
          <Menu theme="dark" mode="horizontal" items={topMenuItems} />
          {/* <Menu.Item key="1" >
                <Link
                to=""
                  onClick={() => {
                    showLogoutConfirm();
                  }}
                >
                  Logout
                </Link>
              </Menu.Item> */}
        </Header>
        <Content style={{ margin: "0 16px" }}>
          <Routes>
            <Route exact path="/" element={<Navigate to="/products" />} />
            <Route exact path="/bookings" element={<Bookings />} />
            <Route exact path="/settings" element={<Setting />} />
            <Route exact path="/contact" element={<ContactLead />} />
            <Route path="/products" element={<ProductList />} />
            <Route path="/products/create" element={<ProductCreate />} />
            <Route path="/products/edit/:id" element={<ProductEdit />} />
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blogs/create" element={<BlogCreate />} />
            <Route path="/blogs/edit/:id" element={<BlogEdit />} />
            <Route path="/investors" element={<InvestorList />} />
            <Route path="/admins" element={<AdminList />} />
            <Route path="/newsletter" element={<NewsletterList />} />
            <Route path="/retailer" element={<RetailerList />} />
            <Route path="/signature-spaces" element={<SignatureSpaceList />} />
            <Route path="/signature-spaces/create" element={<SignatureSpaceCreate />} />
            <Route path="/signature-spaces/edit/:id" element={<SignatureSpaceEdit />} />

            <Route exact path="/logout" element={<Logout />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          {/* Design & Developed by Togglehead */}
        </Footer>
      </Layout>

      <Drawer
        title={t("common.menu")}
        placement="left"
        onClose={onClose}
        open={open}
      >
        {MenuComponent}
      </Drawer>

      <Modal
        title="Change Password"
        open={changePasswordModalOpen}
        onOk={handleChangePassword}
        onCancel={() => {
          form.resetFields();
          setChangePasswordModalOpen(false);
        }}
        confirmLoading={changePasswordLoading}
        okText="Update Password"
        destroyOnClose
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item
            name="oldPassword"
            label="Current Password"
            rules={[{ required: true, message: "Please enter current password" }]}
          >
            <Input.Password placeholder="Current password" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true, message: "Please enter new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Minimum 6 characters" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm New Password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("The two passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
}

export default MainLayout;
